import { render } from "./Valiosa.vue?vue&type=template&id=7a0db2fe&scoped=true"
import script from "./Valiosa.vue?vue&type=script&lang=js"
export * from "./Valiosa.vue?vue&type=script&lang=js"

import "./Valiosa.vue?vue&type=style&index=0&id=7a0db2fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0db2fe"]])

export default __exports__